/* Atelier — "From tree to bottle": pick a step to show its detail (desktop); theme editor block selection. */
if (!customElements.get('atelier-process')) {
  customElements.define(
    'atelier-process',
    class AtelierProcess extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-at-step]'));
        this.panels = Array.from(this.querySelectorAll('[data-at-panel]'));
        this.cards = Array.from(this.querySelectorAll('[data-at-step-card]'));
        this.onClick = (event) => {
          const step = event.target.closest('[data-at-step]');
          if (step && this.contains(step)) this.select(Number(step.dataset.atStep));
        };
        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const step = event.target.closest('[data-at-step]');
          if (!step) return;
          const index = Number(step.dataset.atStep);
          this.select(index);
          const card = this.cards[index];
          if (card && card.offsetParent !== null) {
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        };
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(index) {
        this.steps.forEach((step, i) => {
          const on = i === index;
          step.classList.toggle('is-active', on);
          step.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.panels.forEach((panel, i) => {
          panel.classList.toggle('is-active', i === index);
        });
      }
    }
  );
}
